import { Position, Toaster } from "@blueprintjs/core"
import { ApolloError } from "@apollo/client"

/** Singleton toaster instance. Create separate instances for different options. */
const AppToaster = Toaster.create({
  className: "recipe-toaster",
  position: Position.TOP_RIGHT,
})

export const ErrorToast = (message: any, options?: any) => {
  AppToaster.show(
    {
      message,
      intent: "danger",
      icon: "cross",
      ...options,
    },
    "api-error"
  )
  return false
}

export const SuccessToast = (message: any) => {
  AppToaster.show({
    message,
    intent: "success",
    icon: "tick",
  })
  return true
}

export const ApolloErrorToast = (
  error: ApolloError,
  renderError: (message: string) => any = msg => msg
) => {
  const gqlErrors = error?.graphQLErrors
  const network = error?.networkError

  if (network) {
    ErrorToast(network.message)
  }
  gqlErrors &&
    gqlErrors.forEach(({ message }, idx: any) => {
      AppToaster.show(
        {
          message: renderError(message),
          intent: "danger",
          icon: "cross",
        },
        `apollo-error-${idx}`
      )
    })
  return true
}
export default AppToaster
